module.exports = __webpack_public_path__ + "img/4673f3c.svg";